var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorPaintOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 019 20v-4H6c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 014 14V7c0-1.1.392-2.042 1.175-2.825C5.958 3.392 6.9 3 8 3h12v11c0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0118 16h-3v4c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0113 22h-2zM6 10h12V5h-1v4h-2V5h-1v2h-2V5H8c-.55 0-1.02.196-1.412.588A1.926 1.926 0 006 7v3zm0 4h12v-2H6v2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorPaintOutline);
export default __webpack_public_path__ + "efe38cd804b2d926b8fdd53575bab557.svg";
export { ForwardRef as ReactComponent };